import React from 'react';
import LearnerAuth from '../components/auth/LearnerAuth';
const AuthExample: React.FC = () => {
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-402">
      <LearnerAuth data-id="element-403" />
    </div>;
};
export default AuthExample;